import React from 'react';
import { Button, Table } from 'react-bootstrap';

export default class CheckCardItemDeleteComponent extends React.Component {

    confirmRemove(desc) {
        return confirm('確定移除紀錄: ' + desc + ' ?');
    }

    isDisabled() {
        if (this.props.itemType === '消防衣') {
            return this.props.disabledClothesMod;
        }
        if (this.props.itemType === '消防褲') {
            return this.props.disabledPantMod;
        }
    }



    render() {
        let filterDetails = function (details, target) {
            let ret = [];
            details.map((detail, index) => {
                if (target === detail.checkCategory.description) {
                    ret.push(detail)
                }
            });
            return ret;
        }

        return (
            <Table striped bordered condensed hover>
                <thead>
                    <tr>
                        <th colSpan='4' >{this.props.itemType}</th>
                    </tr>
                    <tr>
                        <th>類別</th>
                        <th>細節</th>
                        <th>附註</th>
                        <th>移除</th>
                    </tr>
                </thead>
                <tbody>
                    {filterDetails(this.props.details, this.props.itemType).map(
                        (detail, index) =>
                            <tr key={index}>
                                <td width="20%">{detail.checkSet.description}</td>
                                <td width="45%">{detail.checkItem.description}</td>
                                <td width="15%">{detail.note}</td>
                                <td width="1%" style={{ textAlign: 'center' }} >
                                    <Button
                                        disabled={this.isDisabled()}
                                        bsStyle="primary"
                                        onClick={(event) => {
                                            if (this.confirmRemove(detail.checkItem.description)) {
                                                this.props.whenClick(detail.id, detail.maintenanceCardId);
                                            }
                                        }}>-</Button>
                                </td>
                            </tr>
                    )}
                </tbody>
            </Table>
        )
    }
};


// WEBPACK FOOTER //
// ./src/components/CheckCardItemDeleteComponent.jsx